<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
      :title="page"
      icon="person"
    ></vuse-section-definition>

    <v-container fluid class="">
      <template>
        <v-card>
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>
              {{ headerTitle }}
            </v-toolbar-title>
            <template v-slot:extension>
              <v-tabs v-model="tab" align-with-title>
                <v-tabs-slider color="yellow"></v-tabs-slider>
                <v-tab> User Profile </v-tab>
                <v-tab v-show="isAdmin"> Company </v-tab>
                <v-tab v-show="isAdmin"> Billing </v-tab>
                <v-tab v-show="isAdmin"> Billing History </v-tab>
                <!-- <v-tab v-show="isAdmin"> Subscription </v-tab> -->
              </v-tabs>
            </template>
          </v-toolbar>
          <v-tabs-items v-model="tab">
            <v-tab-item><UserProfile /></v-tab-item>
            <v-tab-item v-show="isAdmin"><Company /></v-tab-item>
            <v-tab-item v-show="isAdmin"> <Billing /> </v-tab-item>
            <v-tab-item v-show="isAdmin">
              <BillingHistory />
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </template>
    </v-container>
  </div>
</template>



<script>
import { mapActions, mapState } from "vuex";
import { required, email } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import formatterMixin from "src/mixins/formatterMixin";
import Billing from "./Account/_Billing";
import BillingHistory from "./Account/__BillingHistory";
import UserProfile from "./Account/_UserProfile";
import Company from "./Account/_Company";

const validZip = (value) => /^\d{5}(?:[-\s]\d{4})?$/.test(value);

export default {
  components: {
    Billing,
    UserProfile,
    Company,
    BillingHistory,
  },
  mixins: [validationMixin, formatterMixin],
  validations: {
    form: {
      firstName: { required },
      lastName: { required },
      phoneNumber: { required },
      companyName: { required },
      email: { required, email },
      accountAddress: { required },
      accountAddress2: {},
      accountState: { required },
      accountCity: { required },
      accountZipcode: {
        required,
        validZip,
      },
    },
  },
  validationMessages: {
    form: {
      companyName: {
        required: "Required",
      },
      email: {
        required: "Required",
        email: "Email invalid",
      },
      accountZipcode: {
        required: "Zipcode Required",
        validZip: "Zipcode invalid",
      },
      firstName: {
        required: "Required",
      },
      lastName: {
        required: "Required",
      },
      phoneNumber: {
        required: "Required",
      },
      accountAddress: { required: "Required" },
      accountAddress2: { required: "Required" },
      accountState: { required: "Required" },
      accountCity: { required: "Required" },
    },
  },
  data() {
    return {
      namespace: "Account",
      page: "Account",
      usage: "usage",
      tab: "",
      valid: false,
      loading: false,
      editMode: false,
      form: {
        companyName: "",
        email: "",
        phoneNumber: "",
        accountAddress: "",
        accountCity: "",
        accountState: "",
        accountZipcode: "",
        subscriptionId: "",
        firstName: "",
        lastName: "",
      },
    };
  },
  computed: {
    ...mapState({
      company: (state) => state.company.single,
      user: (state) => state.user.single,
      account: (state) => state.account.data,
      isAdmin: (state) => state.account.data.isAdmin,
    }),
    headerTitle() {
      return this.optional(this.company, "companyName", "Company");
    },
  },
  watch: {
    company(n) {
      if (n) {
        this.form = {
          ...n,
        };
      }
    },
  },
  async mounted() {},
  methods: {
    ...mapActions({
      companyGetAccount: "company/getAccount",
      companyUpdate: "company/update",
      userUpdate: "user/update",
      userGetById: "user/getById",
      subscriptionCancel: "subscription/cancelSubscription",
      subscriptionStart: "subscription/startSubscription",
      subscriptionGetStatus: "subscription/getStatus",
    }),

    serverSideErrors() {
      return [];
    },

    async startSubscription() {
      if (confirm("Are you sure will start subscription?")) {
        await this.subscriptionStart();
        await this.subscriptionGetStatus();
      }
    },

    async cancelSubscription() {
      if (confirm("Are you sure will cancel subscription?")) {
        await this.subscriptionCancel();
        await this.subscriptionGetStatus();
      }
    },
  },
};
</script>

<style scoped>
.ci {
  padding: 4px 16px;
}
</style>